import React, { useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import { LeagueResource } from '~~apis/resource';
import LeagueHeader from './LeagueHeader';
import PermissionList from './PermissionList';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
  }
`;

const permissionTooltipMapping = {
  ADMIN: '可進行所有操作，至少需有一位管理者',
  EDITOR: '不得修改管理者權限',
  VIEWER: '僅提供瀏覽管理資訊，不得做任何修改',
};

const LeaguePermission = ({ userInfo, leagues, reload }) => {
  const [leagueIndex, setLeagueIndex] = useState(0);
  const updatePermission = ({ userUniqid, targetUniqid, authority }) => {
    return LeagueResource.updatePermission({ userUniqid, leagueUniqid: targetUniqid, authority });
  };

  return (
    <StyledDiv>
      {leagues.length > 0 && (
        <LeagueHeader leagues={leagues} leagueIndex={leagueIndex} setLeagueIndex={setLeagueIndex} />
      )}
      <PermissionList
        userInfo={userInfo}
        target={leagues[leagueIndex]}
        updatePermission={updatePermission}
        reload={reload}
        permissionTooltipMapping={permissionTooltipMapping}
      />
    </StyledDiv>
  );
};

export default LeaguePermission;
